import { action, computed, makeObservable, observable } from "mobx";
import { PaymentMethodTypes } from "../helpers/paymentMethod";

export interface DictionariesStore {
    banks: string[];
    setBanks: (value: string[]) => void;

    paymentMethods?: PaymentMethodTypes[] | undefined;
    setPaymentMethods: (paymentMethods?: PaymentMethodTypes[] | undefined) => void;
}

export class DefaultDictionariesStore implements DictionariesStore {

    constructor() {
        makeObservable(this);
    }

    @computed
    public get banks() {
        return this._banks;
    }

    @observable
    private _banks: string[] = [];

    @action
    public setBanks(banks: string[]) {
        this._banks = banks;
    }

    @computed
    public get paymentMethods() {
        return this._paymentMethods;
    }

    @observable
    private _paymentMethods: PaymentMethodTypes[] | undefined = [];

    @action
    public setPaymentMethods(paymentMethods: PaymentMethodTypes[] | undefined) {
        this._paymentMethods = paymentMethods;
    }

}

export default new DefaultDictionariesStore();
